<template>
	<ul class="page-breadcrumb">
		<li v-for="(crumb, index) in crumbs">
			<router-link :to="crumb.link" v-if="crumb.link">{{crumb.name}}</router-link>
			<span v-if="!crumb.link">{{crumb.name}}</span>
			<i v-if="index != crumbs.length - 1" class="fa fa-circle"></i>
		</li>
	</ul>
</template>

<script>
/**
 * Breadcrumb module is used to display the crumbs leading to the current page. This module should be used at the top of every main content component.
 * @class Breadcrumb
 * @prop {array} crumbs - The list of crumbs leading to the current page. Each crumb must have a name and an optional link.
 * @since 0.0.2
 */

export default {
	name: 'breadcrumb',
	props: {
		crumbs: {
			default: []
		}
	}
}
</script>


// WEBPACK FOOTER //
// Breadcrumb.vue?1da02698